import {
  IS_GETTING_MEMBER_LIST,
  IS_GETTING_ACTIVE_MEMBERS,
  SET_MEMBERS,
} from './constants';

export default {
  [IS_GETTING_MEMBER_LIST](state, getting) {
    state.isGettingMembers = getting;
  },
  [IS_GETTING_ACTIVE_MEMBERS](state, getting) {
    state.isGettingMembers = getting;
  },
  [SET_MEMBERS](state, members) {
    state.members = members;
  },
};
